import React, { Component } from 'react';
import { LanHeader } from '../../actions/Landing/LanHeader';
import queryString from 'query-string'


export class Landing extends Component {
    displayName = Landing.name

    constructor(props) {
        super(props);
        this.state = {
            numeroGuia: '',
            idModulo: '',
            loading: false,
            token: ''
        };
    }

    componentDidMount() {
        const values = queryString.parse(this.props.location.search);
        this.setState({
            numeroGuia: values.numero_guia,
            idModulo: values.modulo,
            token: values.token
        });
    }

    static renderInit(numeroGuia, idModulo, token) {
        return (
            <div className="contentbody">
                <div className="header">
                    <img className="movil" src="/media/images/Bienvenido.png" />
                    <img className="escritorio" src="/media/images/escritorio/Bienvenido_completo.png" />
                </div>
                <div className="content">
                    <LanHeader numeroGuia={numeroGuia} idModulo={idModulo} token={token} ></LanHeader>
                </div>
            </div>
        );
    }
    
    render() {
        let content = this.state.numeroGuia == '' ? <p><em>Loading...</em></p> : Landing.renderInit(this.state.numeroGuia, this.state.idModulo, this.state.token);

        return (
            <div>
                {content}
            </div>
        );
    }
}
